import Vue from "vue";
import ViewUI from "view-design";

Vue.use(ViewUI);

import "view-design/dist/styles/iview.css";
